import React from 'react';

import { ButtonBase } from '@material-ui/core';
import { DialogComponent } from '../../../../../../Components';
import { AlertCircle } from '../../../../../../assets/icons';

export default function DeleteEntityDialog({
  isOpen,
  parentTranslationPath,
  onClose,
  handleDeleteFunction,
  activeItem,
}) {
  return (
    <DialogComponent
      dialogTitle={
        <div className='delete-entity-wrapper'>
          <div className='delete-icon-wrapper'>
            <AlertCircle
              width='24'
              height='24'
              fill={'#D92D20'}
              style={{ flexShrink: '0' }}
            />
          </div>
          <div className='entity-text-wrapper'>
            <span className='entity-text'>your values will be deleted</span>
            <span className='entity-sub-text'>
              Are you sure you want to delete this information ? This action
              cannot be undone.
            </span>
          </div>
        </div>
      }
      isOpen={isOpen}
      maxWidth={'sm'}
      parentTranslationPath={parentTranslationPath}
      dialogActions={
        <div className='entity-dialog-actions'>
          <ButtonBase
            className='btns theme-propx outlined '
            onClick={onClose}
          >
            Cancel
          </ButtonBase>
          <ButtonBase
            className='btns theme-propx alert'
            onClick={() => {
              handleDeleteFunction(activeItem);
              onClose();
            }}
          >
            delete
          </ButtonBase>
        </div>
      }
    />
  );
}
